import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import Spinner from "../../components/Spinner/Spinner";
import SimilarItems from "../../components/SimilarItems/SimilarItems";
import VideoComponent from "../../components/VideoComponent";
import gameConfig from "../../utils/gamesConfig";
import { useTranslation } from "react-i18next";

const VideoDescription = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [otherItems, setOtherItems] = useState([true]);
  const [selectedItem, setSelectedItem] = useState([true]);
  const params = useParams();
  const { t } = useTranslation("global");
  
  //const { state } = useContext(userContext);
  const { videos, category } = gameConfig;
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {navigate("/login")} 
  },[])

  useEffect(() => {     
    if (videos && videos.length > 0) {
      const sItem = videos.find((item) => item.id == params.id);
      const otherItems = videos.filter((item) => item.category == sItem.category && item.id != params.id);      
      setSelectedItem(sItem, "selected");      
      setOtherItems(otherItems);
      setLoader(false);
    }
  }, [videos, navigate]);

  if (loader)
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spinner />
      </div>
    );
//  console.log(selectedItem)
  return (
    <GameDescriptionStyled>
      <Link to={`/video/${params.id}`}>
        <div className="image-section">
          <VideoComponent 
          videoItem={selectedItem}
          />
        </div>
      </Link>
      <div className="inner-elements"></div>
      <h3>{t("portalText.similarVideos")}</h3>
      <div className="game-collection ">
        <SimilarItems otherItems={otherItems} />
      </div>
    </GameDescriptionStyled>
  );
};

export default VideoDescription;

const GameDescriptionStyled = styled.div`
  min-height: 100vh;

  .image-section {
    height: 30vh;

    img {
      height: 100%;
      width: 100%;
    }
  }
  background-image: linear-gradient(to right, #141e30, #243b55);
  .inner-elements {
    padding: 40px;
  }

  h3 {
    width: 90%;
    color: white;
    font-weight: 400;
    background-image: linear-gradient(to right, #0099f7, #f11712);
    padding: 5px;
    border-radius: 5px;
    margin-left: 10px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
      rgba(0, 0, 0, 0.3) 0px 30px 60px -30px,
      rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
  }
`;
